import { DynamicFormV2Palette } from "@mui/material";

export type FormTooltipComponentTokenType = {
  backgroundColor: string;
  textColor: string;
  iconColor: string;
};

export const assignTooltipComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    textColor: formsPalette.text.reverse,
    iconColor: isLightMode ? formsPalette.text.intense : formsPalette.text.brand,
  } as FormTooltipComponentTokenType;
};
